import { render, staticRenderFns } from "./FeedbackListPage.vue?vue&type=template&id=29afc04a"
import script from "./FeedbackListPage.vue?vue&type=script&lang=ts"
export * from "./FeedbackListPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports